/** 海运分享管理及预览界面的en-US文案。 */
export default {
  auto: {
    tab: 'Auto Sharing',
    create: 'Create auto sharing task',
    edit: 'Edit task',
    detail: 'Task details',
    code: 'Task code',
    generated: 'Generated after saving',
    enabled: 'Task status',
    on: 'Enabled',
    off: 'Paused',
    scheduleEnabled: 'Daily schedule',
    dailyTime: 'Daily execution time',
    zoneId: 'Business time zone',
    scope: 'Sharing scope',
    save: 'Save',
    saved: 'Task settings saved',
    pricePolicy:
      'Automatic and manual sharing apply business markup first, then sales markup for the target channel. Rates without a matching sales rule are skipped. Empty scope includes all valid rates within your permissions.',
    selectionRequired: 'Select at least one rate type and one sharing target',
    masterSwitch: 'Enable automatic sharing',
    masterOff:
      'Automatic sharing is disabled. Tasks stop processing and existing shared rates are kept.',
    masterConfirm:
      'Change automatic sharing? Disabling stops further processing and keeps existing shared rates.',
    manualOnly: 'Manual execution only',
    lastRun: 'Last execution (UTC)',
    progress: 'View results',
    history: 'Execution history',
    run: 'Run now',
    runConfirm:
      'Run this task with current prices and scope? Results will be available in sharing records and execution progress.',
    pause: 'Pause',
    resume: 'Enable',
    delete: 'Delete',
    deleteConfirm: 'Delete this task? It will stop running and existing shared rates will be kept.'
  },
  data: {
    matchFailed: 'Master data could not be matched. Review the missing items.',
    invalid: 'The master-data reference or receiving identity is invalid.',
    serviceUnavailable: 'Master data is temporarily unavailable. Please retry.',
    tooMany: 'This rate references more master-data items than one operation allows.',
    issue: '{type} “{source}”: {reason}',
    issueDetails: 'View matching details',
    unknownType: 'Master data',
    unnamed: 'Unidentified data',
    summary: {
      missing: 'No available {type} “{names}” was found for the recipient',
      sourceMissing: 'No available {type} “{names}” was found for the sender',
      unavailable: 'The sender’s {type} “{names}” or its reference is disabled or unavailable',
      ambiguous: 'Multiple records match {type} “{names}”',
      identityMissing: '{type} “{names}” has no matching code or complete hierarchy',
      unknown: '{type} “{names}” could not be matched; review the details',
      separator: '; '
    },
    reasons: {
      missing: 'No available receiving record or enabled reference',
      ambiguous: 'Multiple receiving records match this identity',
      unavailable: 'The record or reference is disabled',
      sourceMissing: 'The source record cannot be read',
      identityMissing: 'A reliable matching code or complete hierarchy is missing'
    },
    types: {
      SEAPORT: 'Port',
      AIRPORT: 'Airport',
      RAILWAY_STATION: 'Railway station',
      ROUTE: 'Route',
      CARRIER: 'Carrier',
      FEE: 'Charge item',
      BILLING_UNIT: 'Billing unit',
      CURRENCY: 'Currency',
      CONTAINER_TYPE: 'Container type',
      TRANSPORT_TERM: 'Transport term',
      TRADE_TERM: 'Trade term',
      CARGO_TYPE: 'Cargo type',
      COUNTRY: 'Country',
      DIVISION: 'Administrative division',
      TERMINAL: 'Terminal',
      WAREHOUSE: 'Warehouse'
    }
  },
  sync: {
    status: 'Sync status',
    current: 'Synced',
    running: 'Syncing',
    failed: 'Sync failed',
    paused: 'Frozen',
    sourceStopped: 'Source unavailable',
    retry: 'Retry sync',
    lastSyncedAt: 'Last synced: {time}',
    readOnly: 'Received rates are maintained by the source tenant and are view only here.'
  },
  management: {
    myJobs: 'My executions',
    total: 'Total items',
    success: 'Successful',
    failed: 'Failed',
    action: { CANCEL: 'Cancel sharing', RETRY: 'Retry sharing', AUTO: 'Automatic sharing' },
    progress: 'Sharing execution progress',
    loadFailed: 'Could not load results. Refresh to retry.',
    counts: '{total} items, {success} successful, {failed} failed',
    recordId: 'Sharing execution ID',
    allMatched: 'Select all {total} matching records',
    bulkCancel: 'Cancel selected sharing',
    bulkRetry: 'Retry selected records',
    confirm: 'Confirm bulk operation',
    confirmCount:
      'Process {count} selected sharing records? Each item will have a separate result.',
    errors: {
      stopped: 'Automatic sharing stopped. Existing shared rates are kept.',
      tooMany: 'Too many matching records for one task. Narrow the sharing scope and retry.',
      busy: 'The task is running or its settings changed. Refresh and retry.',
      notFound: 'The task or execution record does not exist, or you do not have access.',
      invalid: 'Invalid sharing management parameters. Check the filters or task settings.'
    },
    states: {
      '1': 'Pending',
      '2': 'Running',
      '3': 'Successful',
      '4': 'Failed',
      '5': 'Stopped'
    }
  },
  filters: {
    loadingAddress: 'Loading address',
    addressLoadFailed: 'Unable to load addresses. Open the selector again to retry.',
    routeType: 'Rail route category',
    loadingPort: 'Loading port',
    loadingStation: 'Loading station',
    destinationPort: 'Destination port',
    destinationStation: 'Destination station',
    sourceCity: 'Origin city (master data city name)',
    targetCity: 'Destination city (master data city name)',
    targetRoute: 'Destination route',
    more: 'More filters',
    less: 'Hide filters',
    unlimited: 'All',
    sharedBy: 'Shared by',
    sharedFrom: 'Shared from',
    sharedTo: 'Shared until',
    failedFrom: 'Failed from',
    failedTo: 'Failed until',
    originCountry: 'Origin country',
    originProvince: 'Origin province/state',
    originCity: 'Origin city',
    originDistrict: 'Origin district',
    destCountry: 'Destination country',
    destProvince: 'Destination province/state',
    destCity: 'Destination city',
    destDistrict: 'Destination district',
    serviceType: 'Service type',
    direct: {
      '1': 'Direct',
      '2': 'Transit',
      '3': 'Unspecified'
    },
    service: {
      express: 'Express',
      standard: 'Standard',
      economy: 'Economy',
      priority_freight: 'Priority freight',
      economy_freight: 'Economy freight',
      deferred_freight: 'Deferred freight'
    }
  },
  sourceNotIntegrated:
    'Roll-on/roll-off and breakbulk maintenance sources are not yet integrated into Super Rates. New sharing is temporarily unavailable.',
  partners: 'Partner enterprises',
  partnerSearch: 'Search partner name or code',
  selectPartner: 'Select partner enterprise',
  loadMorePartners: 'Load more partners',
  partnerDisabled: 'Rate sharing is not enabled for this customer',
  partnerRoleIneligible: 'Both customer and supplier roles are required',
  partnerUnbound: 'No unique active receiving tenant matched',
  partnerResultCount: '{count} partner enterprises',
  partnerLoadFailed: 'Could not load partner status. Retry.',
  targetSubmitFailed:
    'Submission failed for: {targets}. Retry to reuse the results already accepted.',
  targetPreviewFailed:
    'Preview failed and submission is disabled for: {targets}. Other available targets can still be shared.',
  libraryReadOnly:
    'This rate is saved in your company library from partner sharing and is read-only.',
  sourcePriceNo: 'Source rate code',
  libraryStates: { active: 'Active', revoked: 'Revoked', expired: 'Expired' },
  loadMode: 'Load mode',
  flightNo: 'Flight number',
  railTrainNo: 'Train number',
  voyageDays: 'Transit days',
  voyageHours: 'Transit hours',
  minBillingWeight: 'Minimum billing weight (KG)',
  volumetricFactor: 'Volumetric factor',
  vehicleType: 'Vehicle type',
  departureTime: 'Departure time',
  arrivalTime: 'Arrival time',
  billingMethod: 'Billing method',
  conditionalFee: 'Included when the service is requested',
  billingMethods: {
    AIR_TICKET: 'Per shipment',
    AIR_CHARGE_WEIGHT: 'Chargeable weight (KG)',
    AIR_ACTUAL_WEIGHT: 'Actual weight (KG)',
    WEIGHT: 'By weight',
    VOLUME: 'By volume',
    WEIGHT_VOLUME_MAX: 'Greater of weight and volume',
    PIECE: 'Per piece',
    TICKET: 'Per shipment',
    TRIP: 'Per trip',
    KM: 'Per kilometre'
  },
  loadModes: { EXPRESS: 'Express', LTL: 'Less than truckload', FTL: 'Full truckload' },
  preport: 'Pre-carriage',
  lastmile: 'On-carriage',
  air: 'Air',
  express: 'Express',
  rail: 'Rail',
  originNode: 'Origin',
  destinationNode: 'Destination',
  startAddress: 'Origin address',
  destinationAddress: 'Destination address',
  unloadPlace: 'Arrival node',
  airline: 'Airline',
  railCompany: 'Rail operator',
  expressCompany: 'Express carrier',
  supplier: 'Supplier',
  originAirport: 'Origin airport',
  destinationAirport: 'Destination airport',
  originStation: 'Origin station',
  destinationStation: 'Destination station',
  cargoType: 'Cargo type',
  transferAirports: 'Transfer airports',
  exitPort: 'Exit port',
  entryPort: 'Entry port',
  transitStations: 'Transit stations',
  transportMode: 'Transport mode',
  billingModel: 'Billing model',
  priceAxis: 'Price component / range',
  priceTable: 'Tariff table',
  viewPriceTable: 'View tariffs',
  priceItemCount: '{count} tariff items',
  density: 'Density',
  step: 'Billing step',
  stdWeight: 'Standard weight',
  minKm: 'Minimum kilometres',
  variant: 'Tariff variant',
  validFrom: 'Valid from',
  components: {
    PICKUP: 'Pickup fee',
    DELIVERY: 'Delivery fee',
    LOADING: 'Loading fee',
    UNIT: 'Unit rate',
    AIR_TIER: 'Air weight tier',
    FIRST_WEIGHT: 'First weight',
    ADDITIONAL_WEIGHT: 'Additional weight',
    WEIGHT_TIER: 'Weight tier',
    WEIGHT_TIER_TOTAL: 'Weight tier total price',
    TRIP: 'Trip',
    KM: 'Kilometre',
    ONE_PRICE: 'One price',
    BASE_PRICE_1: 'Base price 1',
    BASE_PRICE_2: 'Base price 2',
    VOLUME_TIER: 'Volume tier',
    PERCENTAGE: 'Percentage fee'
  },
  billingModels: {
    FIRST_ADDITIONAL: 'First / additional weight',
    UNIT_PRICE: 'Unit price',
    WEIGHT_TIER: 'Weight tiers'
  },
  transportModes: {
    '1': 'Road',
    '2': 'Barge',
    '3': 'Rail',
    集装箱: 'Container',
    container: 'Container',
    CONTAINER: 'Container',
    FCL: 'Container',
    整箱: 'Container',
    整车: 'Full truckload',
    truck: 'Full truckload',
    FTL: 'Full truckload',
    散货: 'Bulk cargo',
    bulk: 'Bulk cargo',
    LTL: 'Bulk cargo',
    LCL: 'Bulk cargo'
  },

  title: 'Rate Sharing',
  presetCount: '{count} rates from rate maintenance have been selected. You can select more.',
  shareSelected: 'Share Selected Rates',
  submitAccepted: 'Sharing Accepted',
  viewResults:
    'Source rates remain unchanged. Open Rate Sharing to view the actual publication results.',
  viewResultsAction: 'View Sharing Results',
  plazaTitle: 'Rate Plaza',
  scope: 'Select available sea rates and preview prices for Family.',
  open: 'New Sharing',
  selectTitle: 'New Sharing — Select Published Rates',
  previewTitle: 'New Sharing — Review Sharing Prices',
  platform: 'Sharing Platform',
  selectTarget: 'Select at least one sharing target.',
  businessType: 'Business Type',
  shareTarget: 'Sharing Target',
  shelfStatus: 'Publication Status',
  published: 'Published',
  priceBasis: 'Price Basis',
  footerSummary: 'Selected {count} rates (kept across pages and types) | {targets} targets',
  previewSummary: 'Selected: {selected} rates; ready to preview: {ready}',
  candidateFailed:
    'Candidate query failed. Check the error for permission or service issues and retry.',
  previewFailed: 'Price preview failed. Check the error and retry.',
  retryQuery: 'Query incomplete. Please retry.',
  noCandidates: 'No shareable rates match the filters',
  noPreview: 'No prices available to preview',
  selectStep: 'Select Rates',
  previewStep: 'Price Preview',
  pricePolicy:
    'Apply business markup first, then sales markup for the sharing target: Family uses the Family channel; partners use CargoWareX. A matching sales rule is required. Zero markup is allowed.',
  searchPlaceholder: 'Rate code',
  search: 'Search',
  reset: 'Reset',
  refresh: 'Refresh Candidates',
  clearSelection: 'Clear Selection',
  fcl: 'FCL',
  lcl: 'LCL',
  roro: 'RoRo',
  bulk: 'Break Bulk',
  chargeMode: 'Pricing Mode',
  byContainer: 'By Container',
  byUnit: 'By Unit',
  mixedCharge: 'By Container / By Unit',
  available: 'Available',
  family: 'Family',
  selected: 'Selected {count} / {max}',
  priceNo: 'Rate Code',
  route: 'Route',
  carrier: 'Carrier',
  por: 'Place of Receipt',
  pol: 'Port of Loading',
  pod: 'Port of Discharge',
  pdl: 'Destination',
  directTransit: 'Direct / Transshipment',
  transferPorts: 'Transshipment Ports',
  vessel: 'Vessel',
  voyage: 'Voyage',
  laneCode: 'Lane Code',
  validTo: 'Valid Until',
  office: 'Company',
  validity: 'Validity',
  noSalesRule: 'No active sales rule matches this channel. This rate cannot be shared.',
  previewStatus: 'Preview Status',
  salesPrice: 'Business Price',
  sharePrice: 'Final Sharing Price',
  status: {
    READY: 'Ready',
    UNAVAILABLE: 'Unavailable or inaccessible',
    NO_PRICE: 'Base freight missing',
    INVALID_PRICE: 'Invalid price or billing data'
  },
  feeType: 'Fee Category',
  feeTypes: {
    '1': 'Ocean Freight',
    '2': 'Origin Fees',
    '3': 'Destination Fees',
    '4': 'Other Fees'
  },
  origin: 'Price Source',
  origins: {
    BASE_FREIGHT: 'Base Freight',
    SOURCE_FEE: 'Source Rate Fee',
    SURCHARGE: 'Matched Surcharge'
  },
  feeName: 'Charge',
  baseFreight: 'Base Freight',
  unit: 'Container / Billing Unit',
  currency: 'Currency',
  minCharge: 'Minimum Charge',
  maxCharge: 'Maximum Charge',
  totalIncluded: 'Included in Total',
  countTotal: 'Count toward Total',
  yes: 'Yes',
  no: 'No',
  empty: '—',
  routeSeparator: '→',
  previewOnly: 'Price preview is ready. Publishing will be available in a later stage.',
  unavailableNotice:
    'Unavailable rates show the reason. Only eligible rates will be submitted.',
  close: 'Close',
  back: 'Back',
  next: 'Next',
  refreshPreview: 'Refresh Prices',
  selectionLimit: 'Select at most {max} rates at a time.',
  confirmHint: 'Confirm to publish to Family. Unavailable records are excluded.',
  confirmShare: 'Confirm Sharing',
  confirmChanged: 'The preview or target changed. Review the prices before confirming again.',
  confirmContent:
    'Publish {count} rates to Family at the previewed prices? {skipped} unavailable records will be skipped.',
  cancel: 'Cancel',
  confirm: 'Confirm',
  submitResult: 'Sharing results: {succeeded} succeeded, {failed} failed, {pending} pending.',
  shareCode: 'Sharing Code',
  copyCode: 'Click to copy the sharing code',
  copied: 'Sharing code copied.',
  copyFailed: 'The browser could not copy the code. Select it manually.',
  publicRateId: 'Family Rate ID',
  shareTime: 'Sharing Time',
  publicationState: 'Visibility',
  active: 'Active',
  inactive: 'Cancelled or Replaced',
  detail: 'Details',
  detailView: {
    title: 'Sharing Record · Rate Details',
    failedTitle: 'Failed Sharing · Rate Details',
    historyTitle: 'Historical Snapshot · Rate Details',
    successLabel: 'Successful Sharing',
    failedLabel: 'Failed Sharing',
    historyLabel: 'Historical Snapshot',
    synced: 'Synced',
    copyCode: 'Copy Sharing Code',
    currentPrices: 'Prices for This Sharing',
    salesSnapshot: 'Sales Price (Snapshot)',
    shareSnapshot: 'Shared Price (Snapshot)',
    containerType: 'Container Type',
    sharingSnapshot: 'Sharing Snapshot',
    sharedBy: 'Shared By',
    lastSyncTime: 'Last Sync Time',
    rateInfo: 'Rate Information',
    basicInfo: 'Basic Information',
    spaceStatus: 'Space Status',
    priceTrend: 'Price Trend',
    routeInfo: 'Route Information',
    schedule: 'Sailing Schedule',
    etd: 'ETD',
    eta: 'ETA',
    carrierInfo: 'Carrier Information',
    contractNo: 'Contract Number',
    nac: 'NAC',
    freeDays: 'Free Period',
    detentionDays: 'Free Detention Days',
    demurrageDays: 'Free Demurrage Days',
    beginDate: 'Start Date',
    endDate: 'End Date',
    notes: 'Remarks',
    overweightNotes: 'Overweight Remarks',
    receivingNotes: 'Receiving Instructions',
    freightDetails: 'Rate Charge Details',
    surchargeDetails: 'Surcharge Details',
    billingUnit: 'Unit',
    unitPrice: 'Unit Price',
    containerUnit: 'Container',
    listSeparator: ', '
  },
  cancelShare: 'Cancel Sharing',
  cancelContent:
    'This rate will be removed from Family. Sharing history will be retained. Cancel sharing?',
  retry: 'Retry',
  failureReason: 'Failure Reason',
  actions: 'Actions',
  refreshRecords: 'Refresh Results',
  recordFailed: 'Sharing results could not be loaded. Check the error and retry.',
  noRecords: 'No sharing records match the filters',
  tabs: { success: 'Shared', failed: 'Failed', pending: 'Pending', history: 'History' },
  errors: {
    invalidPrice:
      'The pricing structure cannot be synchronized completely. Review the source rate and retry.',
    stale: 'The rate or price changed. Preview and share again.',
    sourceUnavailable: 'The source rate is unavailable for sharing.',
    writeFailed: 'Publication failed. Retry is available.',
    supplierNotMatched:
      'The recipient could not match a unique active supplier. Update the supplier records before retrying.',
    replaced: 'Replaced by new sharing or cancellation.',
    accessDenied: 'Sharing permissions are no longer available.',
    accessUnavailable: 'Sharing permissions could not be verified. Retry later.'
  }
}
